import { EMPTY_STRING, Numbers } from '@app/constants';
import { PragmaticProfile } from '@app/interface/pragmatic.profile';

export const PRAGMATIC_PROFILE_INIT: PragmaticProfile = {
  pragmatic_id: Numbers.zero,
  full_name: EMPTY_STRING,
  email: EMPTY_STRING,
  location: {
    ciudad: EMPTY_STRING,
    departamento:EMPTY_STRING,
    pais: EMPTY_STRING,
  },
  profile_photo: EMPTY_STRING,
  view_onboarding: false,
  chapters: [
    {
      order_id: Numbers.zero,
      order_name: EMPTY_STRING,
      chapter_id: Numbers.zero,
      chapter_name: EMPTY_STRING,
      seniority_id: Numbers.zero,
      seniority_name: EMPTY_STRING,
      level_id: Numbers.zero,
      level_name: EMPTY_STRING,
    },
  ],
};
